import { PatientSetting } from "./Enums";

export class PatientVM {
  isNew: boolean;
  id: number;
  firstName: string;
  lastName: string;
  nickName: string;
  dob: any;
  email: string;
  zip: string;
  patientSetting: PatientSetting;
  referralId: Number;
  physicianId: Number;
  departmentId: Number;
  tagIds: Number[];
  diagnosisIds: Number[];
  physicianName?: string;
  isTestPatient: boolean;
  mobilePhone?: string;
  sex?: Number;
  address?: string;
  city?: string;
  mrn?: string;
  dobFormatted?: string;
  medicationIds: Number[];
  age?: string;
  settingFormField: any;
  isPatientRTMEnabled: boolean;
  rtmStartDate?: Date;
  preferredDailyExerciseStartTime?: string;
  isEverEducated: boolean;
  isRtmEverEnabled: boolean;
  externalPatientId: number;
  isSFTPEhrImportEnabled: boolean;
  patientLocationId: number;
  followUpTypeId: Number;
  integrationExternalPendingId?: string | null;
  integrationExternalApprovedId?: number | null;
  integrationStatus?: number | null;
  notes?: string | null;
  roomNumber?: string | null;
}
